import { Controller } from "@hotwired/stimulus"

// Shows the time-zone field only for a country whose zones actually keep
// different time.
//
// Every other country derives correctly from the address — of the countries in
// production only the US and Mexico span several clocks — so asking everyone
// put a 137-item select in front of four signups in five whose right answer was
// already selected. Germany reports two IANA names and one clock; India reports
// four names for one zone.
//
// The field is HIDDEN, never removed. The step tells a deliberate choice from an
// untouched default by posting the value it rendered with
// (Onboarding::AddressesController#chosen_time_zone), and a removed select would
// post nothing, which reads as neither.
export default class extends Controller {
  static targets = ["field"]
  static values = { countryIds: Array, countrySelector: String }

  connect() {
    this.#apply()
  }

  // Delegated: the country select belongs to the address molecule, which is a
  // sibling of this field and carries its own controllers. Listening on the
  // wrapper keeps this one from reaching into another's targets.
  countryChanged(event) {
    if (!event.target.matches(this.countrySelectorValue)) return

    this.#apply()
  }

  #apply() {
    if (!this.hasFieldTarget) return

    const select = this.element.querySelector(this.countrySelectorValue)
    const countryId = Number.parseInt(select?.value, 10)
    this.fieldTarget.hidden = !this.countryIdsValue.includes(countryId)
  }
}
